import React from 'react';

import { ReactComponent as FlowIcon } from './flowIcon.svg';

function FarmbotFlowIcon() {
  return <FlowIcon width={18} />;
}

export default FarmbotFlowIcon;
